import React from "react";

import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import "./styles.scss";

export function MemberHeader({
  age,
  className,
  dayOfCare,
  dob,
  memberName,
  phoneNumber,
  primaryDiagnosis,
  secondaryDiagnosis,
}) {
  return (
    <DashboardCard2
      className={cn("tw:w-full tw:p-5!", className)}
      classNameChildren="tw:flex tw:justify-center tw:p-0"
    >
      <div className="apti-MemberHeader--left-container">
        <p className="apti-MemberHeader--name" data-private>
          {memberName}
        </p>

        <div className="apti-MemberHeader--left-sub-container">
          <span className="apti-MemberHeader--dob">
            {dob} ({age})
          </span>
          <span> • </span>
          <span className="apti-MemberHeader--phone-number">{phoneNumber}</span>
          <span> • </span>
          <span className="apti-MemberHeader--day-of-care">Day {dayOfCare} of care</span>
        </div>
      </div>

      <div className="vertical-break" />

      <div className="apti-MemberHeader--right-container">
        <div className="apti-MemberHeader--primary-diagnosis-container">
          <span className="apti-MemberHeader--primary-diagnosis-title">Primary Diagnosis: </span>
          <span>{primaryDiagnosis}</span>
        </div>

        <div className="apti-MemberHeader--secondary-diagnosis-container">
          <span className="apti-MemberHeader--secondary-diagnosis-title">
            Secondary Diagnosis:{" "}
          </span>
          <span>{secondaryDiagnosis}</span>
        </div>
      </div>
    </DashboardCard2>
  );
}
